import React from 'react';
import SlickSlider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Carousel.css';
import styled, { css } from 'styled-components';
import { IoIosArrowForward } from 'react-icons/io';
import { up } from 'styled-breakpoints';
import Box from '../Box/Box';
import useTheme from '../../hooks/useTheme';
import get from 'lodash/get';
import { BsPersonX } from 'react-icons/all';

const StyledDot = styled.div`
    li {
        width: 28px;
        button {
            :before {
                transition: all 0.2s ease-out;
                color: ${({ theme }) => theme.colors.neutral[200]};
                opacity: 0.75;
                content: '';
                display: block;
                width: 28px;
                height: 2px;
                border-radius: 10px;
                background-color: ${({ theme }) => theme.colors.neutral[700]};
            }
            :hover {
                :before {
                    background-color: ${({ theme }) =>
                        theme.colors.neutral[1300]};
                    opacity: 0.75;
                }
            }
        }
        &.slick-active {
            button {
                :before {
                    background-color: ${({ theme }) =>
                        theme.colors.neutral[1700]};
                    opacity: 1;
                }
            }
        }
    }
`;

const Arrow = ({ rotate, sliderTheme, ...props }) => {
    const arrowStyles = css`
        transform: rotate(${rotate ? '180deg' : '0deg'})
            translateX(${rotate ? '20px' : '0'});
        cursor: pointer;
        color: ${({ theme }) => get(theme.colors, sliderTheme.arrowColor)};
        background-color: ${({ theme }) =>
            get(theme.colors, sliderTheme.arrowBgColor)};
        border-radius: 4px;
        box-sizing: content-box;
        padding: 10px;
    `;
    return (
        <Box {...props}>
            <IoIosArrowForward css={arrowStyles} size={20} />
        </Box>
    );
};

const Slider = React.forwardRef(function SliderComponent(
    {
        mode,
        smOptions = null,
        mdOptions = null,
        lgOptions = null,
        autoplay,
        sliderTheme,
        ...props
    },
    ref
) {
    const {
        theme: { breakpoints },
    } = useTheme();

    return (
        <SlickSlider
            ref={ref}
            responsive={[
                lgOptions && {
                    breakpoint: parseInt(breakpoints.lg),
                    settings: lgOptions,
                },
                mdOptions && {
                    breakpoint: parseInt(breakpoints.md),
                    settings: mdOptions,
                },
                smOptions && {
                    breakpoint: parseInt(breakpoints.sm),
                    settings: smOptions,
                },
            ].filter(Boolean)}
            pauseOnHover={mode !== 'presentation'}
            accessibility={mode !== 'presentation'}
            draggable={mode !== 'presentation'}
            autoplay={autoplay ?? mode === 'presentation'}
            prevArrow={<Arrow rotate sliderTheme={sliderTheme} />}
            nextArrow={<Arrow sliderTheme={sliderTheme} />}
            appendDots={(dots) => (
                <Slider.Dots sliderTheme={sliderTheme}>{dots}</Slider.Dots>
            )}
            {...props}
        />
    );
});

Slider.Dots = StyledDot;

Slider.defaultProps = {
    arrows: false,
    autoplaySpeed: 6000,
};

export default Slider;
